import { LOADING_AUTHOR_CONTEXT, RECEIVED_AUTHOR_CONTEXT, RECEIVED_AUTHOR_CONTEXT_FAILED } from '../../actions/types';
import { createFetcherReducer } from '../utils';

export default createFetcherReducer(
  LOADING_AUTHOR_CONTEXT,
  RECEIVED_AUTHOR_CONTEXT,
  RECEIVED_AUTHOR_CONTEXT_FAILED,
);
